



















































import { defineComponent, computed, ref, PropType } from '@vue/composition-api';
import { i18n } from './../../../../i18n';
import TtamLearnMore from 'src/components/common/learn-more/index.vue';
import LoadingIcon from '@tt4b/ttam-assets/src/svgs/creative/creative-website-url-loading.svg';
import AdaptiveListContainer from '@/components/common/adaptive-list-container/index.vue';

let NOT_START_WITH_HTTP_OR_HTTPS = () => i18n.t('module_ad_url_not_start_with_http_or_https');
let NOT_START_WITH_HTTP = () => i18n.t('module_ad_url_start_with_http');
// URL 建议是否需要展示 learn more的链接
const LEARN_MORE_MAP = () => ({
  [NOT_START_WITH_HTTP_OR_HTTPS() as string]: 'EXTERNAL_URL_WITH_HTTP',
  [NOT_START_WITH_HTTP() as string]: 'EXTERNAL_URL_WITH_HTTP',
});

const name = 'ttam-creative-website-url-check-url';
export default defineComponent({
  name,
  components: {
    AdaptiveListContainer,
    TtamLearnMore,
    LoadingIcon,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    suggestionList: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
  },
  setup(props) {
    const learnMoreInfo = computed(() => LEARN_MORE_MAP());
    const suggestionLearnMoreType = suggestion => learnMoreInfo.value[suggestion] || '';

    return {
      name,
      suggestionLearnMoreType,
    };
  },
});
